var _objectAssign = require('./_objectAssign');

module.exports =
  typeof Object.assign === 'function' ? Object.assign : _objectAssign;



/*****************
 ** WEBPACK FOOTER
 ** ../~/ramda/src/internal/_assign.js
 ** module id = 2
 ** module chunks = 0
 **/